import React, { useEffect, useState } from 'react';
import Loading from '../_components/Loading';
import { NoData } from '../_components/NoData';
import { examService } from '../_services/exam.service';
import { EdraaQuizItem } from './EdraaquizItem';

export const GrandTest = () => {
  //   const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [examList, setExamList] = useState([]);

  useEffect(() => {
    getEdraaquizLIst();
  }, []);
  const getEdraaquizLIst = () => {
    setIsLoading(true);
    setExamList([]);
    examService.grandTestList({ isactive: 1 }).then(
      (res) => {
        setIsLoading(false);

        if (res?.data?.rows?.length) {
          setExamList(res.data.rows);
        } else {
          setExamList([]);
        }
      },
      (err) => {
        console.log(err, 'this is errordata');
        setIsLoading(false);
      },
    );
  };

  return (
    <div className={`${!examList?.length ? 'd-none' : 'mt-5'}`}>
      <div className='d-flex align-items-center mb-3  headcontainer'>
        <div className='home_head '>EdraaQuizz</div>
      </div>
      {!isLoading && (
        <div className='d-flex align-items-center gap-1 justify-content-between'>
          <div className='d-flex flex-wrap gap-4 courselist w-100'>
            {examList?.map((test, index) => {
              return <EdraaQuizItem quizItem={test} key={index} />;
            })}
          </div>
        </div>
      )}
      {isLoading && !examList?.length && <Loading />}
      {!isLoading && !examList?.length && <NoData text='No Grand Test Found' />}
    </div>
  );
};
